export const PORTAL_AUTH_BUTTON_TEST_IDS = {
  signInButton: 'process-management-auth-sign-in-button',
  signOutButton: 'process-management-auth-sign-out-button',
} as const;
